import { LoadingButtonProps } from '@/interfaces/scenarioBuilder.interface'
import Box from '@mui/material/Box' // For flexible layout
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'

const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading,
  onClick,
  children,
  startIcon,
  endIcon,
  disabled,
  variant = 'contained',
  size = 'small',
  ...props
}) => {
  return (
    <Button
      size={size}
      variant={variant}
      onClick={onClick}
      disabled={disabled || loading} // Optionally disable button while loading
      startIcon={startIcon && !loading ? startIcon : null}
      endIcon={endIcon && !loading ? endIcon : null}
      {...props}
    >
      {loading && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: endIcon ? 0 : 1,
            ml: endIcon ? 1 : 0,
          }}
        >
          <CircularProgress size={16} color='inherit' />
        </Box>
      )}
      {children}
    </Button>
  )
}

export default LoadingButton
